import { Builder } from '@builder.io/react';

import FeaturesSideBySide from './index';

Builder.registerComponent(FeaturesSideBySide, {
  name: 'FeaturesSideBySide',
  inputs: [
    {
      name: 'features',
      type: 'list',
      subFields: [
        {
          name: 'overtitle',
          type: 'string'
        },
        {
          name: 'title',
          type: 'string'
        },
        {
          name: 'description',
          type: 'richText'
        },
        {
          name: 'bullets',
          type: 'list',
          subFields: [{ name: 'text', type: 'string' }]
        },
        {
          name: 'link',
          type: 'object',
          subFields: [
            {
              name: 'href',
              type: 'string'
            },
            {
              name: 'name',
              type: 'string'
            }
          ]
        },
        {
          name: 'useSpline',
          type: 'boolean',
          defaultValue: false
        },
        {
          showIf: `options.get('useSpline')`,
          name: 'spline',
          defaultValue: 'https://prod.spline.design/NX6jhAYfLVq7ULPP/scene.splinecode'
        },
        {
          showIf: `!options.get('useSpline')`,
          name: 'images',
          type: 'list',
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            {
              name: 'epigraph',
              type: 'string',
              defaultValue: 'Epigraph'
            },
            {
              name: 'width',
              type: 'number'
            },
            {
              name: 'height',
              type: 'number'
            },
            {
              name: 'alt',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: 'bgGradient',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'bleeds',
      type: 'boolean',
      defaultValue: false
    }
  ]
});
